import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { useMeta } from "@/lib/site";
import { Overline, Reveal } from "@/components/Reveal";
import { Marquee } from "@/components/Marquee";

export default function Story() {
  useMeta("Our Story — The House", "The story of Bonheur Eternal B.E. — a fragrance house built on three principles: Sourced, Crafted, Eternal.");
  const { data: s } = useQuery({ queryKey: ["story"], queryFn: async () => (await api.get("/story")).data });

  return (
    <div className="pt-32 md:pt-44 pb-32">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <Reveal className="max-w-3xl">
          <Overline>The House</Overline>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#2B2118] mt-4 tracking-tight leading-tight">{s?.title}</h1>
        </Reveal>
        <div className="grid lg:grid-cols-2 gap-16 mt-20 items-start">
          <Reveal>
            <div className="overflow-hidden border border-[#2B2118]/[0.07]">
              <img src={s?.image} alt="The atelier" className="w-full object-cover aspect-[4/5]" />
            </div>
          </Reveal>
          <Reveal delay={0.15} className="lg:pt-12">
            {(s?.intro || "").split("\n\n").map((p, i) => (
              <p key={i} className="text-[#5A4C3C] leading-loose mb-6 text-base md:text-lg">{p}</p>
            ))}
          </Reveal>
        </div>
      </div>

      <div className="mt-32">
        {(s?.pillars || []).map((p, i) => (
          <Reveal key={p.title} className="border-t border-[#2B2118]/[0.06]">
            <div className="max-w-7xl mx-auto px-5 md:px-8 py-20 md:py-28 grid md:grid-cols-12 gap-8 items-start">
              <p className="md:col-span-2 font-display text-6xl md:text-7xl text-[#8F6B3A]/30">0{i + 1}</p>
              <h2 className="md:col-span-4 font-display text-3xl md:text-4xl text-[#2B2118] tracking-tight">{p.title}</h2>
              <p className="md:col-span-6 text-[#5A4C3C] leading-loose">{p.body}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Marquee />

      <Reveal className="text-center pt-24 px-5">
        <p className="font-display text-3xl md:text-4xl text-[#2B2118] italic">“Be Remembered.”</p>
        <p className="text-xs tracking-[0.3em] uppercase text-[#6E6151] mt-4">Bonheur Eternal B.E.</p>
      </Reveal>
    </div>
  );
}
